var _a;

import { combine, createContextManager, display, includes } from '@datadog/browser-core';
import { HandlerType, StatusType } from './logger';
export var STATUS_PRIORITIES = (_a = {}, _a[StatusType.debug] = 0, _a[StatusType.info] = 1, _a[StatusType.warn] = 2, _a[StatusType.error] = 3, _a);
export function createSender(sendToHttpImpl, handlerType, level, loggerContext) {
  if (handlerType === void 0) {
    handlerType = HandlerType.http;
  }

  if (level === void 0) {
    level = StatusType.debug;
  }

  if (loggerContext === void 0) {
    loggerContext = {};
  }

  var conf = {
    level: level,
    handlerType: handlerType
  };
  var contextManager = createContextManager();
  contextManager.set(loggerContext);

  function isAuthorized(status, handlerType) {
    var sanitizedHandlerType = Array.isArray(conf.handlerType) ? conf.handlerType : [conf.handlerType];
    return STATUS_PRIORITIES[status] >= STATUS_PRIORITIES[conf.level] && includes(sanitizedHandlerType, handlerType);
  }

  function sendToHttp(message, messageContext, status) {
    if (isAuthorized(status, HandlerType.http)) {
      sendToHttpImpl(combine({
        message: message,
        status: status
      }, contextManager.get(), messageContext));
    }
  }

  function sendToConsole(message, messageContext, status) {
    if (isAuthorized(status, HandlerType.console)) {
      display.log("".concat(status, ": ").concat(message), combine(contextManager.get(), messageContext));
    }
  }

  return {
    getContextManager: function getContextManager() {
      return contextManager;
    },
    setLevel: function setLevel(level) {
      conf.level = level;
    },
    setHandler: function setHandler(handlerType) {
      conf.handlerType = handlerType;
    },
    sendToHttp: sendToHttp,
    sendLog: function sendLog(message, messageContext, status) {
      if (status === void 0) {
        status = StatusType.info;
      }

      sendToHttp(message, messageContext, status);
      sendToConsole(message, messageContext, status);
    }
  };
}